// extracted by mini-css-extract-plugin
module.exports = {"paginate":"BookList_paginate__2UtkI"};